import { RouterLink } from "../Shared/RouterLink";
import React, { useState } from "react";
import {
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Drawer,
	Divider,
	Typography,
	Collapse
} from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

export function NavigationDrawer(props) {
	const actions = [...props.primaryActions, ...props.otherActions];

	return (
		<Drawer open={props.isOpen} onClose={props.toggleOpen}>
			<Typography variant="h6" style={{ padding: 12 }}>
				{props.header}
			</Typography>
			<Divider />
			<NavigationDrawerList actions={actions} {...props} />
		</Drawer>
	);
}

function NavigationDrawerList(props) {
	let dividerCount = 0;
	const [openMenus, setOpenMenus] = useState({});

	const toggleSubMenu = (menuText) => {
		setOpenMenus({
			...openMenus,
			[menuText]: !openMenus[menuText]
		});
	};

	return (
		<List>
			{props.actions.map(a => {
				if (a === "divider") {
					return <Divider key={`divider${dividerCount++}`} style={{ "margin": 8 }} />;
				}

				if (a.subItems) {
					return (
						<React.Fragment key={a.text}>
							<ListItem button onClick={() => toggleSubMenu(a.text)}>
								<ListItemIcon>
									{a.icon}
								</ListItemIcon>
								<ListItemText primary={a.text} />
								{openMenus[a.text] ? <ExpandLess /> : <ExpandMore />}
							</ListItem>
							<Collapse in={openMenus[a.text]} timeout="auto" unmountOnExit>
								<List component="div" disablePadding>
									{a.subItems.map(subItem => (
										<RouterLink
											key={subItem.text}
											to={subItem.url}
											onClick={() => {
												props.toggleOpen();
												if (subItem.onClick)
													return subItem.onClick();
											}}>
											<ListItem button style={{ paddingLeft: 32 }}>
												<ListItemIcon>
													{subItem.icon}
												</ListItemIcon>
												<ListItemText primary={subItem.text} />
											</ListItem>
										</RouterLink>
									))}
								</List>
							</Collapse>
						</React.Fragment>
					);
				}

				return (
					<RouterLink
						key={a.text}
						to={a.url}
						onClick={() => {
							props.toggleOpen();
							if (a.onClick)
								return a.onClick();
						}}>
						<ListItem button>
							<ListItemIcon>
								{a.icon}
							</ListItemIcon>
							<ListItemText primary={a.text} />
						</ListItem>
					</RouterLink>
				);
			})}
		</List>
	);
}
